import WebView, {WebViewMessageEvent} from 'react-native-webview';
import {useWindowDimensions, StyleSheet, View, Pressable} from 'react-native';
import {Svg, Path} from 'react-native-svg';
import {colors, vectors} from 'config/styles';
import {openPage} from 'utils/mediafire';

interface WebFrame {
  url: string,
  exit: () => void,
  onMessage: (e: WebViewMessageEvent) => void,
  isProTrialSignup?: boolean,
}

export function WebFrame(props: WebFrame) {
  const screen = useWindowDimensions();
  const initJS = `
    (function() {
      window.postMessage = function(e) {
        return window.ReactNativeWebView.postMessage(e);
      };
    })();

    setInterval(function() {
      var el = document.getElementById('sharebox-onetimedownload');
      if (el) el.style.boxShadow = 'none';
    }, 200);

    true;
  `;

  return (
    <View style={[styles.root, {height: props.isProTrialSignup ? undefined : screen.height}]}>
      <View style={props.isProTrialSignup ? styles.contentProTrial : styles.content}>
        <WebView
          domStorageEnabled
          nestedScrollEnabled
          scalesPageToFit={false}
          injectedJavaScript={initJS}
          source={{uri: props.url}}
          onMessage={props.onMessage}
          onNavigationStateChange={(e) => {
            if (e.url.includes('/upgrade')) {
              openPage(e.url);
              props.exit();
            }
          }}
        />
        <Pressable onPress={props.exit} style={styles.close}>
          <Svg viewBox="0 0 14 14" width={14} height={14}>
            <Path d={vectors.icons.close} fill={colors.neutral.black}/>
          </Svg>
        </Pressable>
      </View>
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    width: '100%',
    height: 420,
  },
  content: {
    width: '100%',
    height: '100%',
  },
  contentProTrial: {
    width: 580,
    height: 370,
  },
  close: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.8)',
    marginHorizontal: 8,
    marginVertical: 16,
    borderRadius: 99,
    height: 46,
    width: 46,
    right: 8,
    top: 9,
  },
});
